
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import styled from 'styled-components'
import { Layout } from '../components'

const TradeLaw = () => {
    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign:'center'}}>特定商取引法に基づく表記</h1>
            <div className='spacer-50' />
            <Container>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{width: '180px'}}>運営会社</TableCell>
                            <TableCell>ニューネックス株式会社</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>運営責任者</TableCell>
                            <TableCell>代表取締役 藤光謙司</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>所在地</TableCell>
                            <TableCell>〒153-0042 東京都目黒区青葉台1-27-3 2F</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>TEL</TableCell>
                            <TableCell>03-5544-9770</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>MAIL</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>販売価格</TableCell>
                            <TableCell>すべて消費税を含めた価格となっております。</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>送料</TableCell>
                            <TableCell>日本国内への配送料は全国一律：600円（税込）となっております。</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>不良品</TableCell>
                            <TableCell>不良品・ご注文内容と違う製品が届いた場合、料金着払いでご返送ください。<br/>速やかにお取り替えいたしますので、到着日より10日以内にお電話またはメールにてご連絡ください。</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>所在地</TableCell>
                            <TableCell>〒153-0042 東京都目黒区青葉台1-27-3 2F</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>お届け時期</TableCell>
                            <TableCell>製品は、ご注文確認後１週間前後でお届けいたします。<br/>※配送日のご指定をいただいた場合は上記の限りではございません。<br/>※ご注文が集中した場合や地域によってはお届けが遅くなる場合があります。予めご了承ください。<br/>※売り切れ等により製品をお届けできない場合はメールにてご連絡いたします。</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>お支払方法</TableCell>
                            <TableCell>オンラインクレジットカード決済</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>返品</TableCell>
                            <TableCell>大変申し訳ございませんが、基本的には下半身に直接触れる製品ですので返品・交換はご遠慮させていただいております。<br/>ご使用の前によくご確認の上、ご利用ください。</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Container>
            <div className='spacer-100' />
        </Layout>
    )
}
export default TradeLaw

const Container = styled(TableContainer)`
    width: 640px !important;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100% !important;
        padding: 0 20px;
    }
`